<script setup lang="ts">

</script>

<template>
    <aeg-icon icon="pi pi-check" />
</template>

<style scoped lang="scss">

</style>
